import BodyLarge from '../Text/BodyLarge';

const CardRefComparasion = ({ title, specData, className }) => {
  return (
    <section className={className}>
      <BodyLarge className={'font-bold mb-3 uppercase px-8 '}>{title}</BodyLarge>
      <div
        className="pb-8 px-8 mb-6 "
        style={{ borderBottom: '8px solid #E9E9E9', maxWidth: '396px' }}
      >
        {specData?.map((row, idx) => (
          <div className="mb-4" key={idx}>
            <BodyLarge className={'font-normal md:text-base text-xs'}>{row?.title}</BodyLarge>
            <BodyLarge className={'font-bold  max-w-[333px] md:text-base text-xs min-h-[72px]'}>
              {row.description}
            </BodyLarge>
          </div>
        ))}
      </div>
    </section>
  );
};

CardRefComparasion.defaultProps = {};

export default CardRefComparasion;
